<template>
  <layout-main-inner title="证书及晋升">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增证书
      </el-button>
    </div>
    <layout-card-wrap>
      <el-form
        label-width="80px"
        @submit.native.prevent>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="证书编号:">
              <el-input
                v-model="config.certNo"
                clearable
                placeholder="请输入证书编号"
                @clear="handleCurrentChange(1)">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="姓名:">
              <el-input
                v-model="config.userName"
                clearable
                placeholder="请输入姓名"
                @clear="handleCurrentChange(1)">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="身份证:">
              <el-input
                v-model="config.idCertNoLast4"
                clearable
                placeholder="请输入身份证末4位"
                @clear="handleCurrentChange(1)">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态:">
              <el-select
                v-model="config.status"
                clearable
                placeholder="请选择"
                @change="handleCurrentChange(1)">
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="证书等级:">
              <el-select
                v-model="config.level"
                clearable=""
                placeholder="请选择"
                @change="handleCurrentChange(1)">
                <el-option
                  v-for="item in levels"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="">
              <el-button
                type="primary"
                @click="handleCurrentChange(1)">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        border
        :data="list">
        <el-table-column
          label="证书编号"
          min-width="140"
          prop="certNo">
        </el-table-column>
        <el-table-column
          label="姓名"
          width="100"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="手机号"
          width="100"
          prop="mobilePhone">
        </el-table-column>
        <el-table-column
          label="身份证"
          width="140"
          prop="idCertNo">
        </el-table-column>
        <el-table-column
          label="证书文件"
          width="100">
          <template slot-scope="{ row }">
            <el-image
              v-if="row.certFile"
              style="width:60px"
              :src="row.certFile"
              :preview-src-list="[row.certFile]"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="证书等级"
          width="80">
          <template slot-scope="{ row }">
            <span v-if="row.level === 1">一级</span>
            <span v-if="row.level === 2">中级</span>
            <span v-if="row.level === 3">高级</span>
          </template>
        </el-table-column>
        <el-table-column
          label="证书状态"
          width="80">
          <template slot-scope="{ row }">
            <span v-if="row.status === 0">草稿</span>
            <span v-if="row.status === 1">正常</span>
            <span v-if="row.status === 9">过期</span>
          </template>
        </el-table-column>
        <el-table-column
          label="过期时间"
          width="100">
          <template slot-scope="{ row }">
            <span>{{ row.expireDate | dateformat('YYYY-MM-DD') }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="所属考试"
          width="180"
          prop="courseExamName">
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">
            <span>{{ row.createdTime | dateformat() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="145">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange">
      </el-pagination>
    </layout-card-wrap>
    <edit-cert-modal
      ref="cert"
      :callback="() => { getlist() }"
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditCertModal from './edit-cert-modal.vue'
export default {
  name: 'LuxuryIdCertIndex',
  components: { EditCertModal },
  data() {
    return {
      loading: true,
      statusList: [
        { label: '草稿', value: 0 },
        { label: '正常', value: 1 },
        { label: '过期', value: 9 }
      ],
      levels: [
        { label: '一级', value: 1 },
        { label: '中级', value: 2 },
        { label: '高级', value: 3 }
      ],
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        certNo: '',
        userName: '',
        idCertNoLast4: '',
        status: null,
        level: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      this.$refs.cert.update({
        courseCertId: row.courseCertId,
        userId: row.userId,
        userName: row.userName,
        mobilePhone: row.mobilePhone,
        idCertNo: row.idCertNo,
        courseScoreId: row.courseScoreId,
        certNo: row.certNo,
        level: row.level || 1,
        // status: 1,
        expireDate: row.expireDate,
        certFile: row.certFile ? row.certFile.split(',').map(url => ({ url })) : []
      })
    },
    additem() {
      this.$refs.cert.add(this.userInfo.orgId)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该证书?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletecoursecert', {
          payload: {
            courseCertId: row.courseCertId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getcoursecerts', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
